import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { css } from '@emotion/react';
import { Colors, Typography, Button } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import Head from 'next/head';
const Styles = labelStyles('NotFoundPage', {
    root: css({
        display: 'grid',
        margin: '0 auto',
        maxWidth: '1400px',
        paddingBottom: '30px',
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingTop: '30px',
        '@media (min-width: 660px)': {
            paddingBottom: '78px',
            paddingTop: '70px',
        },
    }),
    heading: css(Object.assign(Object.assign({}, Typography.pageHeader1), { color: Colors.neutral800, textAlign: 'center', '@media (min-width: 660px)': Object.assign({}, Typography.pageHeader1) })),
    subtitle: css(Object.assign(Object.assign({}, Typography.base), { color: Colors.gray80, fontSize: '18px', fontWeight: 400, lineHeight: '31px', marginTop: '10px', textAlign: 'center', '@media (min-width: 660px)': {
            marginTop: '20px',
        } })),
    buttonWrapper: css({
        display: 'inline-grid',
        justifyContent: 'center',
        marginTop: '30px',
        '@media (min-width: 660px)': {
            marginTop: '40px',
        },
    }),
});
export function NotFoundPage() {
    return (_jsxs(Fragment, { children: [_jsxs(Head, { children: [_jsx("title", { children: "404: Not found" }), _jsx("meta", { content: "width=device-width, initial-scale=1.0", name: "viewport" }), _jsx("meta", { content: "noindex, nofollow", name: "robots" })] }), _jsxs("div", Object.assign({ css: Styles.root }, { children: [_jsx("h1", Object.assign({ css: Styles.heading }, { children: "404" })), _jsx("h2", Object.assign({ css: Styles.subtitle }, { children: "This is not the page you're looking for." })), _jsx("div", Object.assign({ css: Styles.buttonWrapper }, { children: _jsx(Button, Object.assign({ href: "/" }, { children: "Back to Zapier Homepage" })) }))] }))] }));
}
//# sourceMappingURL=NotFoundPage.js.map